// /lema-frontend/src/lib/browser-detection.ts

// Known in-app browser patterns that may block OAuth flows (pre-lowercased)
const IN_APP_BROWSER_PATTERNS = [
  'instagram',        // Instagram & Threads iOS (same WebView)
  'threadsapp',       // Threads iOS specific
  'threadsandroid',   // Threads Android (some builds)
  'barcelona',        // Threads Android (internal codename — confirmed from device UA)
  'fban',             // Facebook App on Android
  'fbav',             // Facebook App Version
  'fb_iab',           // Facebook In-App Browser
  'fb4a',             // Facebook for Android
  'fbios',            // Facebook for iOS
  'bytedancewebview', // TikTok
  'musical_ly',       // TikTok legacy
  'line/',            // Line messaging app
  'kakaotalk',        // KakaoTalk messaging app
  'twitterandroid',   // Twitter/X Android
  'twitter for',      // Twitter/X iOS
  'linkedinapp',      // LinkedIn
  'snapchat',         // Snapchat
] as const;

/**
 * Detects if the current browser is an in-app browser (social media WebView)
 * that may block OAuth flows.
 *
 * @returns Object with detection results
 */
export function detectInAppBrowser(): {
  isInAppBrowser: boolean;
  browserType: string | null;
} {
  // Server-side or missing navigator
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return { isInAppBrowser: false, browserType: null };
  }

  const userAgent = navigator.userAgent || '';

  // Debug override: ?_iab=1 in URL forces detection to true (for testing UI)
  if (new URLSearchParams(window.location.search).get('_iab') === '1') {
    return { isInAppBrowser: true, browserType: 'debug_override' };
  }

  const lowerUA = userAgent.toLowerCase();
  for (const pattern of IN_APP_BROWSER_PATTERNS) {
    if (lowerUA.includes(pattern)) {
      return {
        isInAppBrowser: true,
        browserType: pattern,
      };
    }
  }

  return {
    isInAppBrowser: false,
    browserType: null,
  };
}
